export default __webpack_public_path__ + "static/media/icon-hotspot-highlight.813251d2.svg";